"use client";
import React from "react";
import { Box, Container, Typography, Button, Stack, Chip } from "@mui/material";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import "../app/globals.css";
import { IMAGES } from "../constants/images";
import { useRouter } from "next/navigation";
import NextLink from "next/link";
const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const router = useRouter();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        py: { xs: 4, sm: 5, md: 6, lg: 8 },
        // boxShadow: "0px -6px 25px rgba(144, 72, 251, 0.2)",
        ml: { xs: "-2%", sm: "-2%", md: "0" },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="xl">
        {/* Main Heading */}
        <Box
          sx={{
            textAlign: isArabic ? "right" : "left",
            mb: { xs: 2, sm: 2.5, md: 2 },
            px: { xs: 2, sm: 3, md: 0, lg: 2, xl: 0 },
          }}
        >
          <Chip
            label={t("heroSection.chip")}
            sx={{
              backgroundColor: "white",
              border: "1px solid #0206174D",
              mb: { xs: 1.5, sm: 2 },
              color: "#818E98",
              fontSize: { xs: "11px", sm: "13px", md: "14px", lg: "16px" },
              fontWeight: "500",
              textTransform: "capitalize",
              px: 0.7,
              py: { xs: 0.8, sm: 1, md: 1.3, lg: 2 },
              fontFamily: "var(--font-outfit)",
              borderRadius: "40px",
            }}
          />

          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontSize: {
                xs: "22px",
                sm: "26px",
                md: "32px",
                lg: "35px",
                xl: "48px",
              },
              fontWeight: 600,
              lineHeight: 1.3,
              color: "#020617",
              mb: { xs: 1.5, sm: 2 },
              maxWidth: { xs: "100%", sm: "95%", md: "100%", lg: "100%" },
              fontFamily: "var(--font-plusjakarta)",
              textAlign: isArabic ? "right" : "left",
            }}
          >
            {t("heroSection.title1")}
            {/* <span style={{ color: "#F4AB00" }}>
              {t("heroSection.titleHighlight1")}
            </span> */}
            {/* {t("heroSection.title2")} */}
            <Box component="span" sx={{ color: "#F4AB00" }}>
              {t("heroSection.titleHighlight2")}
            </Box>
          </Typography>

          {/* <Typography
            variant="body1"
            sx={{
              fontSize: {
                xs: "14px",
                sm: "15px",
                md: "17px",
                lg: "18px",
                xl: "20px",
              },
              color: "#02061799",
              maxWidth: { xs: "100%", sm: "95%", md: "90%", lg: "1100px" },
              fontFamily: "var(--font-outfit)",
              fontWeight: "400",
              mb: 0.3,
              lineHeight: 1.5,
              textAlign: isArabic ? "right" : "left",
            }}
          >
            {t("heroSection.subtitle1")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: {
                xs: "14px",
                sm: "15px",
                md: "17px",
                lg: "18px",
                xl: "20px",
              },
              color: "#02061799",
              fontWeight: "400",
              maxWidth: { xs: "100%", sm: "95%", md: "90%", lg: "1100px" },
              fontFamily: "var(--font-outfit)",
              mt: ".3%",
              lineHeight: 1.5,
              textAlign: isArabic ? "right" : "left",
            }}
          >
            {t("heroSection.subtitle2")}
          </Typography> */}
        </Box>

        {/* Feature Cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "repeat(3, 1fr)" },
            gap: { xs: 2.5, sm: 3, md: 4 },
            mt: { xs: 3, sm: 4, md: 5, lg: 6 },
            maxWidth: "1400px",
            px: { xs: 2, sm: 3, md: 0, lg: 2, xl: 0 },
          }}
        >
          {/* Feature 1 */}
          <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
            <Typography
              sx={{
                fontSize: {
                  xs: "14px",
                  sm: "15px",
                  md: "17px",
                  lg: "17px",
                  xl: "18px",
                },
                fontWeight: 500,
                color: "#020617CC",
                mb: { xs: 1, sm: 1.2, md: 1.5 },
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("heroSection.feature1Title")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                lineHeight: 1.5,
                mb: { xs: 2, sm: 2.5, md: 3 },
                fontFamily: "var(--font-outfit)",
                fontWeight: 400,
                fontSize: {
                  xs: "14px",
                  sm: "15px",
                  md: "16px",
                  lg: "16px",
                  xl: "18px",
                },
                color: "#02061799",
                maxWidth: { xs: "100%", sm: "95%", md: 400 },
              }}
            >
              {t("heroSection.feature1Desc")}
            </Typography>
          </Box>

          {/* Feature 2 */}
          <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
            <Typography
              sx={{
                fontSize: {
                  xs: "14px",
                  sm: "15px",
                  md: "17px",
                  lg: "17px",
                  xl: "18px",
                },
                fontWeight: 500,
                color: "#020617CC",
                mb: { xs: 1, sm: 1.2, md: 1.5 },
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("heroSection.feature2Title")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                lineHeight: 1.5,
                mb: { xs: 2, sm: 2.5, md: 3 },
                fontFamily: "var(--font-outfit)",
                fontWeight: 400,
                fontSize: {
                  xs: "14px",
                  sm: "15px",
                  md: "16px",
                  lg: "16px",
                  xl: "18px",
                },
                color: "#02061799",
                maxWidth: { xs: "100%", sm: "95%", md: 400 },
              }}
            >
              {t("heroSection.feature2Desc")}
            </Typography>
          </Box>

          {/* Feature 3 */}
          <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
            <Typography
              sx={{
                fontSize: {
                  xs: "14px",
                  sm: "15px",
                  md: "17px",
                  lg: "17px",
                  xl: "18px",
                },
                fontWeight: 500,
                color: "#020617CC",
                mb: { xs: 1, sm: 1.2, md: 1.5 },
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("heroSection.feature3Title")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                lineHeight: 1.5,
                mb: { xs: 2, sm: 2.5, md: 3 },
                fontFamily: "var(--font-outfit)",
                fontWeight: 400,
                fontSize: {
                  xs: "14px",
                  sm: "15px",
                  md: "16px",
                  lg: "16px",
                  xl: "18px",
                },
                color: "#02061799",
                maxWidth: { xs: "100%", sm: "95%", md: 400 },
              }}
            >
              {t("heroSection.feature3Desc")}
            </Typography>
          </Box>
        </Box>

        {/* CTA Button */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 2, sm: 2 }}
          alignItems={{ xs: "stretch", sm: "center" }}
          sx={{
            mb: -3,
            mt: { xs: 3, sm: 4, md: "2%" },
            width: "100%",
            px: { xs: 2, sm: 3, md: 0, lg: 2, xl: 0 },
            justifyContent: isArabic ? "flex-start" : "flex-start",
          }}
        >
          <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
            <Button
              component="a"
              // startIcon={
              //   !isArabic && (
              //     <Image
              //       src={IMAGES.EMAIL_LOGO}
              //       alt="Email"
              //       width={24}
              //       height={24}
              //     />
              //   )
              // }
              sx={{
                bgcolor: "#F4AB00",
                color: "#fff",
                textTransform: "none",
                px: { xs: 3, sm: 4, md: 5 },
                py: { xs: 1.8, sm: 2.2, md: 2.6 },
                height: { xs: "48px", sm: "52px", md: "56px" },
                fontFamily: "var(--font-outfit)",
                fontSize: { xs: "0.875rem", sm: "0.9rem", md: "1rem" },
                fontWeight: "500",
                borderRadius: "28px",
                boxShadow: "none",
                width: { xs: "100%", sm: "auto" },
                transition: "all 0.2s ease-in-out",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                "&:hover": {
                  bgcolor: "#000",
                  boxShadow: "none",
                  transform: "scale(1.05) translateY(-2px)",
                },
              }}
            >
              {isArabic ? (
                <>
                  {t("heroSection.cta")}
                  {/* <Image
          src={IMAGES.EMAIL_LOGO}
          alt="Email"
          width={24}
          height={24}
        /> */}
                </>
              ) : (
                t("heroSection.cta")
              )}
            </Button>
          </NextLink>
        </Stack>
      </Container>
    </Box>
  );
};

export default HeroSection;
